import { SafeHTML } from './components/SafeHTML';

export { SafeHTML };
